import React, { useCallback, useEffect, useRef, useState } from "react";
import CoachesCard from "./components/CoachesCard";
import { useParams } from "react-router-dom";
import AddEditCoachDialog from "./components/AddEditCoachModal";
import { upload_image_documents_on_s3 } from "../../../../DAL/jobs/jobs";
import { enqueueSnackbar } from "notistack";
import {
  add_coach,
  edit_coach,
  get_coach_listing,
} from "../../../../DAL/Coach/coach";
import CircularLoader from "../../../../components/loader/CircularLoader";
import RecordNotFound from "../../../../components/recordNotFound/RecordNotFound";
import GeneralMUIDialog from "../../../../components/GeneralMUIDialog/GeneralMUIDialog";
import CoachesFilter from "./components/CoachesFilter";
import TopBar from "../components/TopBar";
import { useIds } from "../../../../hook/AdminContext";
import AppliedFilters from "../../../../components/AppliedFilters/AppliedFilters";
import { CircularProgress } from "@mui/material";
import { plus } from "../../../../assets";

export default function CoachesPage({
  searchText = "",
  filterModal,
  setFilterModal,
  overViewType,
  companyType,
  setOpenEditProfileModal,
  handleOpenCoachDialog,
  setSelectedCoach,
}) {
  const { userInfo, handleGetSectorAccessValue } = useIds();
  const [coachesList, setCoachesList] = useState([]);
  const [filterData, setFilterData] = useState({
    type: null,
    list: "all",
  });
  const [appliedFilterData, setAppliedFilterData] = useState(null);
  const [filterChange, setFilterChange] = useState(false);

  const [insightsToShow, setInsightsToShow] = useState("");

  const topBarList = [
    {
      id: "",
      title: "All Coaches",
    },
    {
      id: userInfo.profile_id,
      title: "My Coaches",
    },
  ];
  const [loading, setLoading] = useState(true);

  const { source_slug, type_slug, feature_slug } = useParams();

  // load more functionality
  const [pageNumber, setPageNumber] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const observer = useRef();

  const lastBookElementRef = useCallback(
    (node) => {
      if (isLoadingMore) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && totalPages > pageNumber) {
          handleLoadMore();
        }
      });
      if (node) observer.current.observe(node);
    },
    [isLoadingMore, totalPages, pageNumber, observer]
  );

  const handleLoadMore = () => {
    setIsLoadingMore(true);
    setPageNumber(pageNumber + 1);
    handleGetCoaches(pageNumber + 1, true);
  };

  const handleAddCoach = () => {
    if (userInfo?.[companyType]?.publish) {
      setSelectedCoach(null);
      handleOpenCoachDialog(true, handleGetCoaches);
    } else {
      setOpenEditProfileModal(true);
    }
  };

  const handleOpenEditCoach = (coach) => {
    setSelectedCoach(coach);
    handleOpenCoachDialog(true, handleGetCoaches);
  };

  const handleGetCoaches = async (page = 0, loadingMore = false) => {
    if (!loadingMore) {
      setLoading(true);
    }
    const resp = await get_coach_listing(
      source_slug,
      searchText,
      filterData?.type?.slug,
      insightsToShow,
      page
    );
    if (resp.code == 200) {
      if (loadingMore) {
        setCoachesList([...coachesList, ...resp.data?.data]);
      } else {
        setCoachesList(resp.data?.data);
      }
      setPageNumber(page);
      setTotalPages(resp.data?.totalPages);
      setAppliedFilterData(filterData);
    } else {
      enqueueSnackbar(resp.message, { variant: "error" });
    }
    setIsLoadingMore(false);
    setLoading(false);
  };

  const handleFilterData = () => {
    setFilterModal(false);
    handleGetCoaches();
  };

  useEffect(() => {
    handleGetCoaches();
  }, [searchText, insightsToShow, filterChange]);

  return (
    <>
      {filterModal && (
        <GeneralMUIDialog
          open={filterModal}
          setOpen={setFilterModal}
          title="Filter"
          actionText="Filter"
          content={
            <CoachesFilter inputs={filterData} setInputs={setFilterData} />
          }
          onSubmit={handleFilterData}
        />
      )}
      <div className="overview-coaches my-3">
        <div className="heading-main-hr mb-3 d-flex justify-content-between align-items-center flex-column flex-md-row flex-nowrap">
          <h6 className="tw-mb-3 mb-0">Mindset Coaches</h6>

          {handleGetSectorAccessValue("allow_manage_coach") &&
            ((userInfo.role == "client" && !userInfo?.isCompanyProfile) ||
              (userInfo?.isCompanyProfile &&
                userInfo?.company_access?.manage_profile?.company_profile)) && (
              <div className="d-flex align-items-center">
                <TopBar
                  classes="tw-w-[270px] me-3 tw-mb-3"
                  items={topBarList}
                  cardToOpen={insightsToShow}
                  setCardToOpen={(value) => {
                    setInsightsToShow(value);
                  }}
                />

                <button
                  className="outlined-btn tw-mb-3 py-3"
                  onClick={() => handleAddCoach()}
                >
                  <img src={plus} className="img-fluid me-2" alt="" height={20} width={20} /> Add New Coach
                </button>
              </div>
            )}
        </div>
        {appliedFilterData && (
          <div>
            <AppliedFilters
              filterData={appliedFilterData}
              setFilterData={setFilterData}
              onFilterChange={() => {
                setFilterChange(!filterChange);
              }}
            />
          </div>
        )}
        {loading ? (
          <CircularLoader />
        ) : coachesList.length > 0 ? (
          <div className="container">
            <div className="row">
              {coachesList.map((item, index) => (
                <>
                  <CoachesCard
                    isCrudAllow={
                      handleGetSectorAccessValue("allow_manage_coach") &&
                      ((userInfo.role == "client" &&
                        !userInfo?.isCompanyProfile) ||
                        (userInfo?.isCompanyProfile &&
                          userInfo?.company_access?.manage_profile
                            ?.company_profile))
                    }
                    item={item}
                    source_slug={source_slug}
                    type_slug={type_slug}
                    handleNavigateDetails={() => { }}
                    handleOpenEditCoach={handleOpenEditCoach}
                    handleGetCoaches={handleGetCoaches}
                    overViewType={overViewType}
                  />
                </>
              ))}
            </div>
          </div>
        ) : (
          <RecordNotFound title="No Coaches" />
        )}

        {!loading &&
          totalPages > 1 &&
          totalPages > pageNumber &&
          coachesList.length > 0 && (
            <div className="col-12 text-center mt-3">
              <div
                ref={lastBookElementRef}
                className="mt-3"
                onClick={() => {
                  handleLoadMore();
                }}
                id="load-more-feed"
              >
                {isLoadingMore ? <CircularProgress size={15} /> : "Load More"}
              </div>
            </div>
          )}
      </div>
    </>
  );
}
